import { AnchorNode, resolveAnchorPath } from '../anchor';

const regexPathWithOffset = /^((([\#0-9a-zA-Z\-\_\.]+)(\[(\d+)\])?)([\/]([\#0-9a-zA-Z\-\_\.]+)(\[(\d+)\])?)*)([+](\d+))?$/i;
const parsePathWithOffset = (input: string) => {
    // tslint:disable
    const m = regexPathWithOffset.exec(input);
    if (m) {
        const selector = m[1];
        const offset = parseInt(m[11], 10);
        return { selector, offset };
    }
    // tslint:enable
};

export const resolvePathWithOffset = (root: AnchorNode, path: string) => {
    const parsed = parsePathWithOffset(path);
    if (!parsed) {
        // tslint:disable-next-line:no-console
        console.warn(`[NoteService] invalid selector: ${path}`);
        return null;
    }
    const resolved = resolveAnchorPath(root, parsed.selector, false);
    if (!resolved || resolved.length === 0) {
        return null;
    }
    if (resolved.length !== 1) {
        // tslint:disable-next-line:no-console
        console.warn(`[NoteService] multiple matches from selector: ${path}`);
    }
    const offset = parsed.offset;
    const selector = parsed.selector;
    const anchor = resolved[0];
    return { anchor, selector, offset };
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/resolvePathWithOffset.tsx